import { showStatusInformer } from './utils';


export const woocommerceFunctions = () => {

  let $;
  $ = require('jquery');

  // Function to update cart after product is added
  function updateCart() {
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: clixsy_params.ajax_url,
      data: {
        'action': 'get_cart_content'
      },
      success: function (response) {
        $('.widget_shopping_cart_content').html(response.cart_html);
        cartNotEmptyIndicator();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error("Response Text:", jqXHR.responseText);
        console.error("Status:", textStatus);
        console.error("Error:", errorThrown);
      }

    });


  }

  function cartNotEmptyIndicator() {
    console.log('cart indicator ==', $('.widget_shopping_cart_content .cart_list li').length)
    if ($('.widget_shopping_cart_content .cart_list li').length > 0) {
      $('.header-cart-btn').addClass('active');
    } else {
      $('.header-cart-btn').removeClass('active');
    }
  }

  function closeMiniCart() {
    $('.widget_shopping_cart_content__wrapper').removeClass('open');
  }

  // Trigger cart update when product is added to cart
  $('body').on('added_to_cart', updateCart);

  // Toggle cart visibility
  $('.header-cart-btn').on('click', function () {
    $('.widget_shopping_cart_content__wrapper').toggleClass('open');
  });

  $('.widget_shopping_cart_content__wrapper .overlay').on('click', function () {
    closeMiniCart();
  });

  $('.widget_shopping_cart_content__wrapper .close').on('click', function () {
    closeMiniCart();
  });





  // CHeck for added_to_cart event
  $(document.body).on('added_to_cart removed_from_cart', function () {
    cartNotEmptyIndicator();
  });

  // Reviews stars
  $('.product-info-stars .star').on('click', function () {
    let ratingValue = $(this).data('rating');
    let productId = $(this).parent().parent().data('product-id');
    console.log(ratingValue)
    console.log(productId)

    // Create a dynamic cookie name based on the product ID
    let cookieName = 'product_' + productId + '_rated';

    // Check if user has already rated THIS product
    if (document.cookie.includes(cookieName)) {
      showStatusInformer(5000, 'You have already rated this product');
      return;
    }

    $(this).prevAll().addBack().css('color', 'gold');
    $(this).nextAll().css('color', 'gray');

    // AJAX request to rate the product
    $.post(clixsy_params.ajax_url, {
      action: 'rate_product',
      product_id: productId,
      rating: ratingValue,
    }, function (response) {
      if (response.success) {
        showStatusInformer(5000, response.data.message);
        document.cookie = cookieName + "=true; max-age=86400; path=/";
      } else {
        showStatusInformer(5000, 'An error occurred. Please try again.');
      }
    });
  });


  // add to cart button


  $('.quick-to-cart').on('submit', function (e) {
    e.preventDefault();

    // Extract data from the form
    var product_id = $(this).find('[name="add-to-cart"]').val();
    var quantity = $(this).find('[name="quantity"]').val();

    $.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
      data: {
        product_id: product_id,
        quantity: quantity
      },
      dataType: 'json',
      success: function (response) {
        if (response && response.fragments) {
          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
          showStatusInformer(5000, 'Product added to <a href="/cart/">cart</a>');

        } else {
          // Handle error
          showStatusInformer(5000, 'Failed to add product to cart.');
        }
      }
    });

  });
}